// eslint-disable-next-line no-use-before-define
import React from 'react';
import {
    connect,
    useDispatch
} from 'react-redux';
import { Redirect, Route } from 'react-router';
import { RootStateType } from '../redux-store/reducers';
import { logout } from '../redux-store/actions/auth';

export type AuthRoutePropsType = {
    path: string;
    component: React.ComponentType<any>;
    isLoggedIn: boolean;
    exact?: boolean;
    role?: string;
    acceptedRoles?: string[];
};

function PaymentProtectedRoute({
    component: Component,
    render,
    isLoggedIn,
    role = '',
    acceptedRoles = [],
    ...rest
}: AuthRoutePropsType & { render?: (props: any) => JSX.Element }): JSX.Element {
    const dispatch = useDispatch();

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                const { pathname } = routeProps.location;
                const paymentId = pathname.split('/')[2];

                if (!isLoggedIn) {
                    return (
                        <Redirect
                            to={{
                                pathname: `/payment-flow/${paymentId}/payment-login`,
                                state: { from: routeProps.location },
                            }}
                        />
                    );
                }

                if (!acceptedRoles.includes(role)) {
                    return (
                        <div>
                            <p>You are not authorized to view this page</p>
                            <button onClick={() => dispatch(logout())}>Logout</button>
                        </div>
                    );
                }

                // Render the component or use the render prop
                if (render) {
                    return render(routeProps);
                }

                return Component ? <Component {...routeProps} /> : null;
            }}
        />
    );
}

export default connect(
    ({ auth }: RootStateType) => ({ isLoggedIn: !!auth.token, role: auth.role }),
    {}
)(PaymentProtectedRoute);
